<template>
  <AuthShell
    title="Login"
    subtitle="Completing Google login."
    :show-hero="false"
  >
    <div class="auth-panel__section">
      <h2 class="auth-panel__title">Signing you in</h2>
      <p class="auth-panel__helper">Please wait.</p>
    </div>

    <div v-if="errorMessage" class="auth-panel__section">
      <div class="auth-error-message" data-testid="google-auth-error">{{ errorMessage }}</div>
    </div>
  </AuthShell>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import AuthShell from '../components/AuthShell.vue'
import { useAuthStore } from '../stores/auth'
import { safeRedirectPath } from '../utils/auth'

const route = useRoute()
const router = useRouter()
const auth = useAuthStore()
const errorMessage = ref('')

onMounted(async () => {
  try {
    const response = await fetch('/api/v1/auth/session', {
      credentials: 'same-origin',
    })
    if (!response.ok) {
      throw new Error('Session token request failed.')
    }
    const data = await response.json()
    auth.setTokens(data.access, data.refresh, data.username)
    await router.replace(safeRedirectPath(route.query.redirect, '/home'))
  } catch {
    auth.clearTokens()
    errorMessage.value = 'Google login failed. Please try again.'
    await router.replace('/login?googleError=oauth')
  }
})
</script>
